import {
  type FeatureFlagValues,
  featureFlagDefaultValues,
} from '@seen/core/featureFlags'
import { createContext } from 'react'

export const FeatureFlagContext = createContext<FeatureFlagValues>(
  featureFlagDefaultValues
)
